export default function (history, refDate) {
  let pos = 0;
  while (refDate.getTime() < new Date(history[pos]?.valid_from).getTime()) {
    pos++;
  }
  return parseFloat(history[pos]?.rate || 0);
}
